import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

const { t } = i18n.global

export const DiscountMarkupsPages = {
  list: 'ListDiscountMarkups',
  add: 'AddDiscountMarkups',
  edit: 'EditDiscountMarkups',
}

const title = t('forms.discountMarkups')
const path = '/discount-markups'
const breadcrumb = [{ title, path }]

const discountMarkupsComponent = () =>
  import('@/pages/mainPageWithRoute/discount-markups/FormDiscountMarkupsPage.vue')

const Add: RouteRecordRaw = {
  path: 'add',
  name: DiscountMarkupsPages.add,
  component: discountMarkupsComponent,
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: DiscountMarkupsPages.edit,
  component: discountMarkupsComponent,
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: DiscountMarkupsPages.list,
  component: () => import('@/pages/mainPageWithRoute/discount-markups/ListDiscountMarkupsPage.vue'),
  meta: { title, requiresAuth: true },
}

export const DiscountMarkups: RouteRecordRaw = {
  path,
  name: 'DiscountMarkups',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
